import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-us">
      <h1>Find Us</h1>
      <div className="contact-us-content">
        <div className="contact-us-content1">
          <h2>JackThePilot</h2>
          <h3>Jounieh</h3>
        </div>
        <div className="map-section">
          <div className="gmap-frame">
            <iframe
            title="Google Map"
              width="100%"
              height="600"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=33.99266905803202,%2035.639655252312906+(Jack%20The%20Pilot)&amp;t=h&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            >
              <a href="https://www.mapsdirections.info/fr/calculer-la-population-sur-une-carte">
                mesurer la population sur une carte
              </a>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
